import { render, staticRenderFns } from "./ChartSummary.vue?vue&type=template&id=47d45e64&scoped=true&"
import script from "./ChartSummary.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChartSummary.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ChartSummary.vue?vue&type=style&index=0&id=47d45e64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d45e64",
  null
  
)

export default component.exports